module.exports = __webpack_public_path__ + "img/canvas.d4fe5ad7.png";